module.exports = __webpack_public_path__ + "static/Product-Summary-Interactive-Smart-Board-5f2007d8ed516686b87d4906f5aacb37.jpg";